// /src/hooks/use-hero.ts
import { useState } from "react";
import type { Swiper } from "swiper";
import { getHeroData } from "@/data/hero-data";
import { useLanguage } from "@/lib/i18n";

export function useHero() {
  const [activeSlide, setActiveSlide] = useState(0);
  const { language } = useLanguage();

  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  const handleSlideChange = (swiper: Swiper) => {
    setActiveSlide(swiper.realIndex);
  };

  const heroData = getHeroData(language);

  return {
    activeSlide,
    handleScrollDown,
    handleSlideChange,
    slides: heroData.slides,
  };
}
